// types.ts
export interface SuturesData {
  uspSize: string;
  metricSize: string;
  diameterMin: string;
  diameterMax: string;
  avgMaxOversize?: string;
  avgKPTS: string;
}

export const suturesTlacRows: SuturesData[] = [
  {
    uspSize: "6-0",
    metricSize: "0.7",
    diameterMin: "0.070",
    diameterMax: "0.099",
    avgMaxOversize: "0.015",
    avgKPTS: "0.25",
  },
  {
    uspSize: "5-0",
    metricSize: "1",
    diameterMin: "0.10",
    diameterMax: "0.149",
    avgMaxOversize: "0.025",
    avgKPTS: "0.68",
  },
  {
    uspSize: "4-0",
    metricSize: "1.5",
    diameterMin: "0.15",
    diameterMax: "0.199",
    avgMaxOversize: "0.030",
    avgKPTS: "0.95",
  },
  {
    uspSize: "3-0",
    metricSize: "2",
    diameterMin: "0.20",
    diameterMax: "0.249",
    avgMaxOversize: "0.040",
    avgKPTS: "1.77",
  },
  {
    uspSize: "2-0",
    metricSize: "3",
    diameterMin: "0.30",
    diameterMax: "0.339",
    avgMaxOversize: "0.030",
    avgKPTS: "2.68",
  },
  {
    uspSize: "0(1-0)",
    metricSize: "3.5",
    diameterMin: "0.35",
    diameterMax: "0.399",
    avgMaxOversize: "0.050",
    avgKPTS: "3.90",
  },
  {
    uspSize: "1",
    metricSize: "4",
    diameterMin: "0.40",
    diameterMax: "0.499",
    avgMaxOversize: "0.040",
    avgKPTS: "5.08",
  },
  {
    uspSize: "2",
    metricSize: "5",
    diameterMin: "0.50",
    diameterMax: "0.599",
    avgMaxOversize: "0.030",
    avgKPTS: "6.35",
  },
  {
    uspSize: "3&4",
    metricSize: "6",
    diameterMin: "0.600",
    diameterMax: "0.699",
    avgMaxOversize: "0.030",
    avgKPTS: "7.29",
  }
];


export const suturesTsorbRows: SuturesData[] = [
  {
    uspSize: "6-0",
    metricSize: "0.7",
    diameterMin: "0.070",
    diameterMax: "0.099",
    avgKPTS: "0.25",
  },
  {
    uspSize: "5-0",
    metricSize: "1",
    diameterMin: "0.10",
    diameterMax: "0.149",
    avgKPTS: "0.68",
  },
  {
    uspSize: "4-0",
    metricSize: "1.5",
    diameterMin: "0.15",
    diameterMax: "0.199",
    avgKPTS: "0.95",
  },
  {
    uspSize: "3-0",
    metricSize: "2",
    diameterMin: "0.20",
    diameterMax: "0.249",
    avgKPTS: "1.77",
  },
  {
    uspSize: "2-0",
    metricSize: "3",
    diameterMin: "0.30",
    diameterMax: "0.339",
    avgKPTS: "2.68",
  },
  {
    uspSize: "0(1-0)",
    metricSize: "3.5",
    diameterMin: "0.35",
    diameterMax: "0.399",
    avgKPTS: "3.90",
  },
  {
    uspSize: "1",
    metricSize: "4",
    diameterMin: "0.40",
    diameterMax: "0.499",
    avgKPTS: "5.08",
  },
  {
    uspSize: "2",
    metricSize: "5",
    diameterMin: "0.50",
    diameterMax: "0.599",
    avgKPTS: "6.35",
  },
  {
    uspSize: "3&4",
    metricSize: "6",
    diameterMin: "0.600",
    diameterMax: "0.699",
    avgKPTS: "7.29",
  }
];

